import InvestInvesmentsNew from './InvestInvesmentsNew';

export default InvestInvesmentsNew;
